export enum IncidentStatus {
  NOT_DONE = 'notDone',
  TODO = 'todo',
  DONE = 'done',
}
